import React from 'react'
import { Layout } from '../components/layout/Layout'
import { HeadingMd } from '../components/heading/Heading'
import { TextBanner } from '../components/text-banner/TextBanner'

const PrivacyverklaringPage = () => {
  return (
    <Layout title="Privacyverklaring" desc="">
      <TextBanner>
        <HeadingMd h={2}>Privacyverklaring</HeadingMd>
      </TextBanner>
    </Layout>
  )
}

export default PrivacyverklaringPage
